<div>
    <app-audi-text variant="order4" className="audi-type-normal"
        text="Choose existing customer if you are looking for a Freeway plan for your Audi, or you can browse to see what plans are available on new or other Audis.">
    </app-audi-text><br /><br />
    <div class="tooltip-container" style="display:inline-flex;">
        <app-audi-button text="Existing Customer" (click)="onExistingCustomer()"></app-audi-button>
        <app-tooltip style="margin-left:10px;" tooltipText="{{contentTooltips | ContentTooltip:'Existing Customer'}}"></app-tooltip>
    </div>
    <br /><br />
    <!--<app-audi-button text="Just Browsing" (click)="onJustBrowsing()">
    </app-audi-button>-->
</div>
